<template>
	<div class="max-w-3xl lg:max-w-4xl xl:max-w-5xl mx-auto px-8 py-8 text-ihh-midnight-gray">
		<!-- Header Section -->
		<h1 class="text-3xl font-bold text-center mb-10">Custom Birth Kit Service</h1>

		<!-- Overview + Image Float Section -->
		<div class="mb-8 md:mb-12 relative">
			<h2 class="text-xl font-bold mb-4">📦 We make it easy for midwives</h2>

			<p class="mb-4">
				Here at <span class="font-semibold">In His Hands Birth Supply</span>, we make it easy for midwives & birth centers to set up and manage custom birth kits
				tailored to their unique practice and client needs.
			</p>

			<!-- Floated image starts here -->
			<img src="/images/christin_mission_wwa.jpg" alt="Birth Kit Mission" class="mx-auto md:mx-0 md:float-right w-64 md:w-72 md:ml-6 mb-4 rounded-lg shadow-md" />

			<p class="mb-6">
				We understand the vital role midwives play in supporting expectant mothers through their birth journey. We have simplified the process of setting up and
				managing a custom birth kit. We understand that every midwife's practice is unique, and so are the specific needs of their clients. Our service is designed to
				provide complete flexibility, allowing midwives to tailor their kit to reflect their individual preferences and the needs of each family they serve.
			</p>

			<!-- Why Choose section stays inside same float context -->
			<h2 class="text-xl font-bold mb-4 mt-8">✅ Why Choose Our Custom Birth Kit Service?</h2>
			<ul class="space-y-3 list-disc pl-5">
				<li><span class="font-semibold">100% Customizable</span> — You choose exactly what goes in each kit.</li>
				<li><span class="font-semibold">Easy to order</span> — Clients can order online anytime from your unique kit page.</li>
				<li><span class="font-semibold">Time-Saving</span> — No more managing inventory or printing off order forms.</li>
				<li><span class="font-semibold">Fast Shipping</span> — Most birth kits ship within 24 hours.</li>
				<li>
					<span class="font-semibold">Easy Editing - <em>NEW!</em></span> — You can modify your own custom birth kit anytime from your online account.
				</li>
				<li><span class="font-semibold">Reliable Inventory</span> — Professionally packed with quality supplies, we consistently stock.</li>
				<li><span class="font-semibold">No Setup Fees</span> — Creating a kit is 100% free.</li>
			</ul>

			<!-- Clear the float before next section -->
			<div class="clear-both"></div>
		</div>

		<!-- How-To Section -->
		<div class="mb-10">
			<h2 class="text-xl font-bold mb-4">👶🏻 How to Create A New Birth Kit</h2>
			<ul class="space-y-2 list-disc pl-5">
				<li>
					<router-link to="/login" class="text-ihh-dark-salmon hover:underline">Log in</router-link> or create an account
					<router-link to="/register" class="text-ihh-dark-salmon hover:underline">here</router-link>
				</li>
				<li>
					Go to Birth Kits on your account
					<router-link to="/account/birth-kits" class="text-ihh-dark-salmon hover:underline">page</router-link>
				</li>
				<li>Click "New Birth Kit"</li>
				<li>Name your kit</li>
				<li>Add your logo</li>
				<li>Search our entire catalog and choose the default and optional items you would like to have in your birth kit</li>
				<li>Submit your kit for approval <span class="italic">(usually takes just a few hours!)</span></li>
				<li>Once approved, you can share the link with your clients for easy ordering</li>
				<li>You can then modify your birth kit at any time directly from your account</li>
			</ul>
		</div>

		<!-- Edit Section -->
		<div class="mb-10">
			<h2 class="text-xl font-bold mb-4">🔄 How to Edit Your Existing Birth Kit</h2>
			<p class="mb-4">
				Midwives with custom birth kits already built can now edit their kit anytime from their account page — add, remove, and change quantities on default and
				optional items as their supply needs evolve. No need to call or email — our website offers full control!
			</p>
			<p class="mb-4">
				To get started,
				<router-link to="/login" class="text-ihh-dark-salmon hover:underline">log in</router-link>, then
				<router-link to="/categories/midwife-birth-kits/" class="text-ihh-dark-salmon hover:underline">navigate</router-link> to your birth kit page and click "Claim
				My Kit" to attach it to your account.
			</p>
			<p class="mb-8">
				If you have any questions or would like help building your kit, please feel free to
				<router-link to="/help-center" class="text-ihh-dark-salmon hover:underline">contact us</router-link>. We are happy to help!
			</p>
		</div>

		<!-- CTA Button -->
		<div class="text-center">
			<router-link
				to="/account/birth-kits"
				class="bg-ihh-dark-salmon hover:bg-ihh-salmon text-ihh-white font-semibold py-3 px-24 rounded-lg text-lg transition-colors duration-200 inline-block"
			>
				Get Started
			</router-link>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CustomBirthKitService',
	data() {
		return {}
	},
	methods: {},
}
</script>

<style scoped></style>
